import {
  Button,
  LayoutGridContainer,
  LayoutVerticalSpacer,
  Supplementary,
  TextField,
} from '@madpaws/design-system';
import { useFormikContext } from 'formik';
import React from 'react';

import { PHONE_INPUT_MASK } from '~/common/constants/app';
import { ErrorBoundary } from '~/components/AuthenticationProvider/ErrorBoundary/ErrorBoundary';

import styles from './MobileNumber.module.css';

import type { ChangeEvent } from 'react';
import type { ReactElement } from 'react';
import type { MobileNumberFormValues } from '~/components/AuthenticationProvider/MobileNumberDialog/MobileNumberDialog';

type Props = {
  apiError?: string | null;
  isAPILoading?: boolean;
};

export const MobileNumberForm = ({ apiError, isAPILoading }: Props): ReactElement => {
  const {
    isSubmitting,
    submitForm,
    setFieldValue,
    values,
    isValid,
  } = useFormikContext<MobileNumberFormValues>();

  const isSubmitButtonDisabled = isSubmitting || !isValid;

  const onTextFieldChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { name, value },
    } = event;

    setFieldValue(name, value);
  };

  return (
    <LayoutGridContainer rowGap="small2x">
      <LayoutVerticalSpacer space="small4x">
        <ErrorBoundary fieldName="mobileNumber">
          <TextField
            isLabelVisuallyHidden
            label="Mobile Number"
            mask={PHONE_INPUT_MASK}
            name="mobileNumber"
            onChange={onTextFieldChange}
            placeholder="0400 000 000"
            type="tel"
            value={values.mobileNumber}
          />
        </ErrorBoundary>

        <Supplementary>Enter a valid 10-digit mobile (04XX XXX XXX)</Supplementary>

        <>{apiError && <p className={styles.error}>{apiError}</p>}</>

        <Button
          isDisabled={isAPILoading || isSubmitButtonDisabled}
          isFullBleed
          label="Add"
          onClick={submitForm}
        />
      </LayoutVerticalSpacer>
    </LayoutGridContainer>
  );
};
